export const STAKEHOLDER_VIEW = 'STAKEHOLDER_VIEW';
export const STAKEHOLDER_ACTION_VIEW = 'STAKEHOLDER_ACTION_VIEW';
export const STAKEHOLDER_UPDATE = 'STAKEHOLDER_UPDATE';